import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const RejectApplicantModal = ({ open, onClose, onReject, applicant }) => {
  const [loading, setLoading] = useState(false);

  if (!applicant) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Rechazar Solicitud</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          ¿Estás seguro que deseas rechazar la solicitud de:
        </Typography>
        <Typography variant="h6" color="error">
          {applicant.nombre} {applicant.apellido}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={async () => {
            setLoading(true);
            try {
              await onReject(applicant);
            } finally {
              setLoading(false);
            }
          }}
          color="error"
          variant="contained"
          disabled={loading}
        >
          {loading ? "Rechazando..." : "Confirmar Rechazo"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectApplicantModal;